import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 15H11M4 19H8M12 15H20M9 19H15M4.75 12V11.7703L5.59234 9.24324M5.59234 9.24324L7.50676 3.5H7.96622L9.88063 9.24324L10.723 11.7703V12M9.88063 9.24324H5.59234" />
	</SVG>
);
